import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const ReasonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
  max-height: 312px;
  margin-top: ${props => props.theme.spacing.sp8};
  overflow-x: hidden;
  overflow-y: auto;
`
